export enum ConfirmationPagesTypes {
  forgotPassword = 'resendForgottenPassword',
  registration = 'resendEmail',
  createTvToGoAccount = 'requestToCreateTvToGoAccount',
}
